import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex w-full items-center gap-5 rounded-full bg-white p-2 pr-5',
    imageWrapper:
      'relative size-18 shrink-0 overflow-hidden rounded-full max-lg:size-16 max-md:size-15',
    title: 'heading-m max-lg:heading-s line-clamp-2',
    icon: 'ml-auto size-6 shrink-0'
  }
});
